import type { IntlKey } from 'locales';
import type { FC } from 'react';
import { ModalHeader } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { fromTradeCancellation } from 'state/selectors';
import type { AppState } from 'state/state.model';

interface Props {
  tradeId: string;
}

export const TradeCancellationModalHeader: FC<Props> = ({ tradeId }) => {
  const externalQuoteId = useSelector((state: AppState) =>
    fromTradeCancellation.getTradeCancellationExternalQuoteId(state, tradeId),
  );
  const fileCode = useSelector((state: AppState) => fromTradeCancellation.getTradeCancellationFileCode(state, tradeId));
  const iconKey = useSelector((state: AppState) => fromTradeCancellation.getIconByStatus(state));
  const translationKeyByStatus = useSelector(fromTradeCancellation.getTranslationKeyForStatus);
  const statusColor = useSelector(fromTradeCancellation.getStatusColor);

  return (
    <ModalHeader>
      <div className="d-flex flex-column">
        <div className="d-flex justify-content-between">
          <button
            className={`mb-3 btn bg-${statusColor} bg-opacity-10 btn-lg p-2 rounded-circle text-${statusColor} pe-none`}
          >
            <em className="icon icon-md ">{iconKey}</em>
          </button>
        </div>

        <h3 className={`modal-title text-${statusColor}`}>
          <FormattedMessage id={`tradeCancellation.title.${translationKeyByStatus}` as IntlKey} />
        </h3>
        <p className="text-secondary">
          {`${externalQuoteId}${tradeId ? ' / ' + tradeId : ''}${fileCode ? ' / ' + fileCode : ''}`}
        </p>
      </div>
    </ModalHeader>
  );
};
